import React, {Component} from 'react';
import {withRouter, Route, Switch, Redirect} from 'react-router-dom';
import {renderToStaticMarkup} from 'react-dom/server';
import {withLocalize} from 'react-localize-redux';
import {connect} from 'react-redux';

import './App.css';

import enTranslation from '../../06-assets/translations/en.json';
import viTranslation from '../../06-assets/translations/vi.json';

import HomePage from '../_pages/Home';
import AuthPage from '../_pages/Auth';
import AdminPage from '../_pages/Admin';
import ErrorPage from '../_pages/Error';
import MaintainPage from '../_pages/Maintain';

class App extends Component {
	constructor(props) {
		super(props);
		
		props.initialize({
			languages: [
				{code: "en"},
				{code: "vi"},
			],
			options: {renderToStaticMarkup}
		});
		props.addTranslationForLanguage(enTranslation, "en");
		props.addTranslationForLanguage(viTranslation, "vi");
		
	}
	
	render() {
		return (
			<div className="app">
				<Switch>
					<Route path="/maintain" component={MaintainPage}/>
					<Route path="/auth" component={AuthPage}/>
					<Route path="/admin" component={AdminPage}/>
					<Route path="/error" component={ErrorPage}/>
					<Route path="/" component={HomePage}/>
					<Redirect to="/error/404"/>
				</Switch>
			</div>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		systemStatus: store.system.systemStatus
	};
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default withRouter(withLocalize(connect(mapStateToProps, mapDispatchToProps)(App)));



// WEBPACK FOOTER //
// ./src/04-containers/App/App.js